import React from 'react';
import styled from 'styled-components';

const StyledPardotForm = styled.iframe`
  width: 100%;
  border: none;
`;

const PardotForm = ({ url, height, ...props }) => (
  <StyledPardotForm
    title="Pardot Form"
    src={url}
    height={height}
    {...props}
  ></StyledPardotForm>
);

export default PardotForm;
